import React from "react";
// import FormProgress from "../UnitAdmin/FormProgress";
import FormProgress from "../AuditAdmin/FormProgress";
import GapAssesmentAccordion from "./GapAssesmentAccordion";

const GapAssesment = () => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Gap Assessment</div>
        <GapAssesmentAccordion />
      </div>
    </>
  );
};

export default GapAssesment;
